import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-picture",
  "use": "icon-si-glyph-picture-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-picture\" id=\"icon-si-glyph-picture\"><title>661</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\"><path d=\"M13.842,4 L9.912,1.15 C9.755,0.491 9.166,0 8.458,0 C7.717,0 7.106,0.537 6.984,1.243 L2.918,4 L0.0209999999,4 L0.0209999999,13.96 L15.959,13.96 L15.959,4 L13.842,4 L13.842,4 Z M8.458,3 C9.014,3 9.492,2.695 9.752,2.247 L11.8945312,4.00000002 L5.04663086,4.00000002 L7.213,2.336 C7.483,2.736 7.94,3 8.458,3 Z M11.9605786,10.0845944 L8.719654,11.7576284 L4.99291992,7.03894043 L1,13 L1,5 L15,5 L15,13 L11.9605786,10.0845944 Z\" class=\"si-glyph-fill\" /><circle cx=\"12.963\" cy=\"6.963\" r=\"0.963\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-picture.svg
// module id = 1R7o
// module chunks = 62